import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { fetchCharacterDetails } from '../api/api'
import { AxiosError } from 'axios'
import backgroundImage from '../assets/images/bg_3_xs.webp'

interface CharacterDetailsData {
	Name: string
	CLevel: number
	Class: string
	ResetCount?: number
	Guild?: string | null
	Online?: boolean
}

const CharacterDetails: React.FC = () => {
	const { name } = useParams<{ name: string }>()
	const navigate = useNavigate()
	const [character, setCharacter] = useState<CharacterDetailsData | null>(null)
	const [loading, setLoading] = useState<boolean>(true)

	useEffect(() => {
		const handleUnauthorized = () => {
			navigate('/')
		}

		window.addEventListener('unauthorized', handleUnauthorized)

		const fetchData = async () => {
			try {
				const response = await fetchCharacterDetails(name!)
				setCharacter(response.data)
			} catch (error) {
				const axiosError = error as AxiosError
				console.error('Error fetching character details:', axiosError)
				if (axiosError.response?.status === 401) {
					navigate('/')
				}
			} finally {
				setLoading(false)
			}
		}

		fetchData()

		return () => {
			window.removeEventListener('unauthorized', handleUnauthorized)
		}
	}, [name, navigate])

	if (loading) {
		return <div className='text-center text-white'>Loading...</div>
	}

	if (!character) {
		return <div className='text-center text-red-500'>Character not found</div>
	}

	return (
		<div
			className='min-h-screen text-white bg-cover bg-center bg-fixed p-6'
			style={{
				backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${backgroundImage})`,
			}}
		>
			<h2 className='text-3xl font-semibold text-yellow-400 mb-6'>
				Character Details
			</h2>
			<div className='bg-gray-800 bg-opacity-90 p-6 rounded-lg shadow-lg'>
				<h3 className='text-2xl font-bold text-red-400'>{character.Name}</h3>
				<p className='text-gray-300 mt-2'>
					Level: <span className='text-white'>{character.CLevel}</span>
				</p>
				<p className='text-gray-300 mt-1'>
					Class: <span className='text-white'>{character.Class}</span>
				</p>
				<p className='text-gray-300 mt-1'>
					Reset Count:{' '}
					<span className='text-white'>{character.ResetCount || 0}</span>
				</p>
				<p className='text-gray-300 mt-1'>
					Guild: <span className='text-white'>{character.Guild || 'None'}</span>
				</p>
				<p className='text-gray-300 mt-1'>
					Status:{' '}
					<span
						className={character.Online ? 'text-green-400' : 'text-red-400'}
					>
						{character.Online ? 'Online' : 'Offline'}
					</span>
				</p>
			</div>
		</div>
	)
}

export default CharacterDetails
